import { usdtAbi, LOTTERY_ABI, STAKE_ABI } from "./abi";
import { Notify } from "vant";
import store from "@/store";
import Web3 from "web3";
import {
  USDT_ADDRESS,
  RAD_ADDRESS,
  LOTTERY_ADDRESS,
  STAKE_ADDRESS,
} from "./constants";

export {
  USDT_ADDRESS,
  RAD_ADDRESS,
  LOTTERY_ADDRESS,
  STAKE_ADDRESS,
} from "./constants";

export let gasPrice = "3000000000";
let web3Provider;
export let WEB3;
export let web3js;
let { ethereum } = window;

/** 从 store 读取当前连接的钱包地址 */
export function getAccountAddress() {
  return store.state.user.accountAddress;
}

/** BSC 主网 chainId；97 为 BSC 测试网 */
const networkVersion = "56";
export let isChainId = true;

/** BSC 公开 RPC：无注入钱包时的默认节点 */
export const PUBLIC_RPC_URL = "https://bsc-dataseed.binance.org";

const readOnlyWeb3 = new Web3(new Web3.providers.HttpProvider(PUBLIC_RPC_URL));

if (ethereum) {
  web3Provider = ethereum;
} else if (window.web3) {
  web3Provider = web3.currentProvider;
} else {
  web3Provider = new Web3.providers.HttpProvider(PUBLIC_RPC_URL);
}
WEB3 = new Web3(web3Provider);

let tokenContractInstance;
let radContractInstance;
let lotteryContractInstance;
let stakeContractInstance;

let readUsdtContract;
let readRadContract;
let readLotteryContract;
let readStakeContract;

function createReadContracts(web3) {
  readUsdtContract = new web3.eth.Contract(usdtAbi, USDT_ADDRESS);
  readRadContract = new web3.eth.Contract(usdtAbi, RAD_ADDRESS);
  readLotteryContract = new web3.eth.Contract(LOTTERY_ABI, LOTTERY_ADDRESS);
  readStakeContract = new web3.eth.Contract(STAKE_ABI, STAKE_ADDRESS);
}

createReadContracts(readOnlyWeb3);

export function getReadWeb3() {
  return web3js || readOnlyWeb3;
}

export function getWriteWeb3() {
  return web3js || null;
}

export function getUsdtContract() {
  return tokenContractInstance || readUsdtContract;
}

export function getRadContract() {
  return radContractInstance || readRadContract;
}

export function getLotteryContract() {
  return lotteryContractInstance || readLotteryContract;
}

export function getStakeContract() {
  return stakeContractInstance || readStakeContract;
}

export async function checkNetwork(web3Instance) {
  try {
    const res = await web3Instance.eth.net.getId();
    if (String(res) !== networkVersion) {
      isChainId = false;
      Notify({ type: "danger", message: "error network" });
    } else {
      isChainId = true;
    }
  } catch (err) {
    //
  }
}

export const contractInstanceInit = function (provider, account) {
  web3js = provider;
  store.commit("SET_ADDRESS", account);
  checkNetwork(web3js);
  web3js.eth.getGasPrice().then((res) => {
    gasPrice = res;
  });
  const fromAddress = getAccountAddress();
  return new Promise((resolve) => {
    tokenContractInstance = new web3js.eth.Contract(usdtAbi, USDT_ADDRESS, {
      from: fromAddress,
      gasPrice: "0",
    });
    radContractInstance = new web3js.eth.Contract(usdtAbi, RAD_ADDRESS, {
      from: fromAddress,
      gasPrice: "0",
    });
    lotteryContractInstance = new web3js.eth.Contract(
      LOTTERY_ABI,
      LOTTERY_ADDRESS
    );
    stakeContractInstance = new web3js.eth.Contract(STAKE_ABI, STAKE_ADDRESS);
    createReadContracts(web3js);
    resolve();
  });
};
